import React from 'react';
import { theme } from '../styles/theme';

// Richiesta di conferma per azioni irreversibili
function ConfirmModal({ title, message, confirmLabel = 'Conferma', onConfirm, onCancel, busy = false }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.content}>
        <h2 style={styles.title}>{title}</h2>
        <p style={styles.message}>{message}</p>
        <div style={styles.actions}>
          <button onClick={onCancel} style={styles.cancel} disabled={busy}>Annulla</button>
          <button onClick={onConfirm} style={busy ? styles.confirmDisabled : styles.confirm} disabled={busy}>
            {busy ? 'Attendere...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    width: '420px',
    maxWidth: '90%',
  },
  title: {
    marginTop: 0,
    marginBottom: '10px',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  message: {
    fontSize: '15px',
    color: theme.colors.text,
    marginBottom: '20px',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  cancel: {
    padding: '8px 16px',
    backgroundColor: theme.colors.white,
    color: theme.colors.text,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  },
  confirm: {
    padding: '8px 16px',
    backgroundColor: '#b70e0e',
    color: theme.colors.white,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  },
  confirmDisabled: {
    padding: '8px 16px',
    backgroundColor: theme.colors.border,
    color: theme.colors.white,
    border: 'none',
    borderRadius: '4px',
    cursor: 'not-allowed',
    fontSize: '14px',
  },
};

export default ConfirmModal;
